<div class="bumps-container">
  <div class="bumps">
    <div class="bump bump-1"></div>
    <div class="bump bump-2"></div>
    <div class="bump bump-3"></div>
  </div>
</div>
